import { all, fork } from 'redux-saga/effects';
import appSaga from './app';
import authSaga from './auth';
import productSaga from './product';
import categoryItemSaga from './category';
import categoryListSaga from './category/list';
import categoryInsertSaga from './category/insert';
import categoryUpdateSaga from './category/update';
import categoryDeleteSaga from './category/delete';
import storeSaga from './stores';
import citySaga from './city';
import userSaga from './user';
// import reportsActivitiesDoneSaga from './reportActivities';
import childrenSaga from './children';
import groupSaga from './group';
import orderSaga from './order';
import pageSaga from './page';
import profileAccessSaga from './profileAccess';
import productColorSaga from './productColor';
import productSizeSaga from './productSize';
import bankSaga from './bank';
import bannerSaga from './banner';
import addressSaga from './address';
import trendSaga from './trend';
import kitSaga from './kit';
import reportSaga from './report';
import walletSaga from './wallet';
import shoppingSaga from './shopping';
import virtualCatalogSaga from './virtualCatalog';
import scrollSaga from './scroll';
import couponSaga from './coupon';
import dashboardSaga from './dashboard';
import dashboardTimelineSaga from './dashboard/timeline';
import dashboardGeneralSaga from './dashboard/general';
import withdrawSaga from './wallet/withdraw';
import publicGlobalItemSaga from './publicGlobal';
import globalItemSaga from './global';
import globalUpdateSaga from './global/update';
import moduleListSaga from './module/list';
import moduleInsertSaga from './module/insert';
import moduleUpdateSaga from './module/update';
import moduleSaga from './module';
import moduleDeleteSaga from './module/delete';
import activityByModuleSaga from './module/activity/byModule';
import activityInsertSaga from './module/activity/insert';
import activityUpdateSaga from './module/activity/update';
import activitySaga from './module/activity';
import activityDeleteSaga from './module/activity/delete';
import moduleCategoryListSaga from './module/category/list';
import moduleCategoryItemSaga from './module/category';
import moduleCategoryInsertSaga from './module/category/insert';
import moduleCategoryUpdateSaga from './module/category/update';
import moduleCategoryDeleteSaga from './module/category/delete';
import attachmentModuleInsertSaga from './attachment/insert';
import attachmentModuleByActivitySaga from './attachment/byActivity';
import attachmentModuleDeleteSaga from './attachment/delete';
import attachmentModuleEditSaga from './attachment/update';
import blogCategoryItemSaga from './blog/category';
import blogCategoryListSaga from './blog/category/list';
import blogCategoryInsertSaga from './blog/category/insert';
import blogCategoryUpdateSaga from './blog/category/update';
import blogCategoryDeleteSaga from './blog/category/delete';
import groupChildItemSaga from './groupChild';
import groupChildListSaga from './groupChild/list';
import groupChildInsertSaga from './groupChild/insert';
import groupChildUpdateSaga from './groupChild/update';
import groupChildDeleteSaga from './groupChild/delete';
import interestItemSaga from './interest';
import interestListSaga from './interest/list';
import interestInsertSaga from './interest/insert';
import interestUpdateSaga from './interest/update';
import interestDeleteSaga from './interest/delete';
import attachmentModuleSaga from './attachment';
import attachmentByModuleSaga from './attachment/byModule';
import blogPostItemSaga from './blog/post';
import blogPostListSaga from './blog/post/list';
import blogPostInsertSaga from './blog/post/insert';
import blogPostUpdateSaga from './blog/post/update';
import blogPostDeleteSaga from './blog/post/delete';
import validateHashSaga from './account/validate';
import validateAccount from './account/validateAccount';

import globalsStatus from './globalsStatus/actions';

export default function* rootSaga() {
  yield all([
    fork(appSaga),
    fork(authSaga),
    fork(productSaga),
    fork(categoryItemSaga),
    fork(categoryListSaga),
    fork(categoryInsertSaga),
    fork(categoryUpdateSaga),
    fork(categoryDeleteSaga),
    fork(storeSaga),
    fork(citySaga),
    fork(userSaga),
    fork(childrenSaga),
    fork(groupSaga),
    fork(orderSaga),
    fork(pageSaga),
    fork(profileAccessSaga),
    fork(productColorSaga),
    fork(productSizeSaga),
    fork(bankSaga),
    fork(bannerSaga),
    fork(addressSaga),
    fork(trendSaga),
    fork(kitSaga),
    fork(reportSaga),
    fork(walletSaga),
    fork(shoppingSaga),
    fork(virtualCatalogSaga),
    fork(scrollSaga),
    fork(couponSaga),
    fork(dashboardSaga),
    fork(dashboardTimelineSaga),
    fork(dashboardGeneralSaga),
    fork(withdrawSaga),
    fork(publicGlobalItemSaga),
    fork(globalItemSaga),
    fork(globalUpdateSaga),
    fork(moduleListSaga),
    fork(moduleInsertSaga),
    fork(moduleUpdateSaga),
    fork(moduleSaga),
    fork(moduleDeleteSaga),
    fork(activityByModuleSaga),
    fork(activityInsertSaga),
    fork(activityUpdateSaga),
    fork(activitySaga),
    fork(activityDeleteSaga),
    fork(attachmentModuleInsertSaga),
    fork(attachmentModuleByActivitySaga),
    fork(attachmentModuleDeleteSaga),
    fork(attachmentModuleEditSaga),
    fork(attachmentModuleSaga),
    fork(attachmentByModuleSaga),
    fork(blogCategoryItemSaga),
    fork(blogCategoryListSaga),
    fork(blogCategoryInsertSaga),
    fork(blogCategoryUpdateSaga),
    fork(blogCategoryDeleteSaga),
    fork(blogPostItemSaga),
    fork(blogPostListSaga),
    fork(blogPostInsertSaga),
    fork(blogPostUpdateSaga),
    fork(blogPostDeleteSaga),
    fork(groupChildItemSaga),
    fork(groupChildListSaga),
    fork(groupChildInsertSaga),
    fork(groupChildUpdateSaga),
    fork(groupChildDeleteSaga),
    fork(interestItemSaga),
    fork(interestListSaga),
    fork(interestInsertSaga),
    fork(interestUpdateSaga),
    fork(interestDeleteSaga),
    fork(validateHashSaga),
    fork(validateAccount),
    fork(globalsStatus),
    fork(moduleCategoryListSaga),
    fork(moduleCategoryItemSaga),
    fork(moduleCategoryInsertSaga),
    fork(moduleCategoryUpdateSaga),
    fork(moduleCategoryDeleteSaga),
    // fork(reportsActivitiesDoneSaga),
  ]);
}
